export default __webpack_public_path__ + "img/0f67926e9ff12aca737815e1e2b5ea40.svg";